import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./renn/Logo";
import { LEGAL } from "../legalContent";
import { FOOTER } from "../mock";

const LegalPage = () => {
  const { slug } = useParams();
  const doc = LEGAL[slug];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <div className="renn-bg min-h-screen">
      <div className="relative z-10">
        <header className="border-b border-[#29354A] bg-[#050A12]/80 backdrop-blur-xl">
          <div className="max-w-4xl mx-auto px-5 lg:px-8 h-[72px] flex items-center justify-between">
            <Link to="/" aria-label="Renn home" className="inline-flex items-center">
              <img src="/renn-logo.png" alt="Renn" className="h-7 lg:h-8 w-auto" draggable={false} />
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-[#8290A8] hover:text-[#13D99A] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" /> Back to home
            </Link>
          </div>
        </header>

        <main className="max-w-3xl mx-auto px-5 lg:px-8 py-16 lg:py-24">
          {!doc ? (
            <div>
              <h1 className="font-display text-3xl font-bold text-[#F5F7FB]">Page not found</h1>
              <p className="mt-4 text-[#8290A8]">
                We couldn't find that document.{" "}
                <Link to="/" className="text-[#13D99A]">Return home</Link>.
              </p>
            </div>
          ) : (
            <>
              <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Legal</p>
              <h1 className="font-display text-4xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
                {doc.title}
              </h1>
              <p className="mt-3 text-sm text-[#8290A8]">{doc.updated}</p>
              <p className="mt-6 text-lg text-[#8290A8] leading-relaxed">{doc.intro}</p>

              <div className="mt-10 space-y-9">
                {doc.sections.map((s, i) => (
                  <section key={i}>
                    <h2 className="font-display text-xl font-bold text-[#F5F7FB] mb-3">{s.heading}</h2>
                    <div className="space-y-3">
                      {s.body.map((p, j) => (
                        <p key={j} className="text-[#8290A8] leading-relaxed">{p}</p>
                      ))}
                    </div>
                  </section>
                ))}
              </div>

              <p className="mt-12 pt-8 border-t border-[#29354A] text-xs text-[#8290A8]/80 leading-relaxed">
                {FOOTER.disclaimer}
              </p>
              <p className="mt-3 text-xs text-[#8290A8]">{FOOTER.copyright}</p>
            </>
          )}
        </main>
      </div>
    </div>
  );
};

export default LegalPage;
